import { DEFAULT_DRAFT_NARRATIVE_NAME } from '../../../utilities/constants';

/** Builds the Project History card for a saved Insights Draft. */
export const buildDraftNarrative = ({ draft, projectId }) => {
  const hasDraftNarrative =
    draft && (Array.isArray(draft?.topics) ? draft.topics.length > 0 : false);

  if (!hasDraftNarrative || !projectId) return null;

  return {
    id: `draft-${projectId}`,
    isOwner: true,
    name: draft?.narrativeName?.trim() || DEFAULT_DRAFT_NARRATIVE_NAME,
    status: 'DRAFT',
  };
};
